import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export type VideoToGraphSyncState = {
  videos: {
    [key: string]: {
      currentTime: number;
    };
  };
};
type SetVideoCurrentTimePayload = {
  videoType: string;
  currentTime: number;
};

const initialState: VideoToGraphSyncState = {
  videos: {
    initial: { currentTime: 0 },
    followup: { currentTime: 0 },
  },
};

const { reducer, actions } = createSlice({
  name: "videoToGraphSyncSlice",
  initialState,
  reducers: {
    setVideoCurrentTime: (
      state,
      { payload }: PayloadAction<SetVideoCurrentTimePayload>
    ) => {
      const { videoType, currentTime } = payload;
      state.videos[videoType].currentTime = currentTime;
    },
  },
});

export const { setVideoCurrentTime } = actions;

export default reducer;
